import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import Backend from 'i18next-http-backend'
import LanguageDetector from 'i18next-browser-languagedetector'

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'ru', // используем "ru", если язык не определён
    debug: false,

    detection: {
      order: ['localStorage', 'navigator'], // сначала localStorage, потом браузер
      caches: ['localStorage'], // сохраняем выбор в localStorage
    },

    interpolation: {
      escapeValue: false,
    },

    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
  })
  .then(() => {
    const currentLng = i18n.language || 'ru'
    document.documentElement.dir = currentLng === 'ar' ? 'rtl' : 'ltr'
  })
